<template>
  <v-dialog :value="value" @input="close" :persistent="loading" max-width="450">
    <v-form @submit="changePassword">
      <v-card>
        <v-toolbar color="primary" dark flat>
          <v-icon class="mr-2">mdi-lock</v-icon>
          <v-toolbar-title>เปลี่ยนรหัสผ่าน</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-text-field
            id="password"
            label="รหัสผ่านเก่า"
            name="password"
            prepend-icon="mdi-lock"
            type="password"
            required
            v-model="password"
            :error-messages="passwordErrors"
            :disabled="loading"
            @input="$v.password.$touch()"
            @blur="$v.password.$touch()"
          ></v-text-field>
          <v-text-field
            id="newPassword"
            label="รหัสผ่านใหม่"
            name="newPassword"
            prepend-icon="mdi-lock"
            type="password"
            required
            v-model="newPassword"
            :error-messages="newPasswordErrors"
            :disabled="loading"
            @input="$v.newPassword.$touch()"
            @blur="$v.newPassword.$touch()"
          ></v-text-field>
          <v-text-field
            id="confirmPassword"
            label="ยืนยันรหัสผ่านใหม่"
            name="confirmPassword"
            prepend-icon="mdi-lock"
            type="password"
            required
            v-model="confirmPassword"
            :error-messages="confirmPasswordErrors"
            :disabled="loading"
            @input="$v.confirmPassword.$touch()"
            @blur="$v.confirmPassword.$touch()"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text :disabled="loading" @click="close">ยกเลิก</v-btn>
          <v-btn color="primary" :disabled="loading" :loading="loading" type="submit">บันทึก</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required, sameAs } from "vuelidate/lib/validators";
export default {
  mixins: [validationMixin],
  props: {
    value: { type: Boolean, default: false },
  },
  validations: {
    password: { required },
    newPassword: { required },
    confirmPassword: { required, sameAs: sameAs("newPassword") },
  },
  data: () => {
    return {
      loading: false,
      password: "",
      newPassword: "",
      confirmPassword: "",
    };
  },

  computed: {
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push("กรุณาใส่รหัสผ่านเก่า");
      return errors;
    },
    newPasswordErrors() {
      const errors = [];
      if (!this.$v.newPassword.$dirty) return errors;
      !this.$v.newPassword.required && errors.push("กรุณาใส่รหัสผ่านใหม่");
      return errors;
    },
    confirmPasswordErrors() {
      const errors = [];
      if (!this.$v.confirmPassword.$dirty) return errors;
      !this.$v.confirmPassword.required &&
        errors.push("กรุณายืนยันรหัสผ่านใหม่");
      !this.$v.confirmPassword.sameAs && errors.push("รหัสผ่านใหม่ไม่ตรงกัน");
      return errors;
    },
  },
  methods: {
    /** ปิด dialog + ล้างฟอร์ม (ปิดไม่ได้ระหว่างส่งข้อมูล) */
    close() {
      if (this.loading) return;
      this.password = "";
      this.newPassword = "";
      this.confirmPassword = "";
      this.$v.$reset();
      this.$emit("input", false);
    },
    async changePassword($e) {
      $e.preventDefault();
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.loading = true;
      try {
        const data = await this.$store.dispatch("auth/changePassword", {
          password: this.password,
          newPassword: this.newPassword,
          confirmPassword: this.confirmPassword,
        });

        if (data && data.success && data.success == true) {
          this.$notify({
            type: "success",
            title: "สำเร็จ!",
            text: "ทำการเปลี่ยนรหัสผ่านเรียบร้อย กรุณา Login ใหม่อีกครั้ง",
          });
          this.loading = false;
          this.close();
          this.$store.dispatch("auth/clearToken");
          this.$store.dispatch("auth/logout");
          this.$router.push({
            path: "/login",
          });
        } else if (data && !data.success && data.message) {
          this.$notify({
            type: "error",
            title: "Error",
            text: data.message,
          });
        } else {
          this.$notify({
            type: "error",
            title: "Error",
            text: "พบปัญหากับระบบกรุณาลองใหม่อีกครั้งภายหลัง",
          });
        }
      } catch (err) {
        const errMsg =
          (err &&
            err.response &&
            err.response.data &&
            err.response.data.message) ||
          err.message ||
          "พบปัญหากับระบบกรุณาลองใหม่อีกครั้งภายหลัง";
        this.$notify({
          type: "error",
          title: "Error",
          text: errMsg,
        });
      }
      this.loading = false;
    },
  },
};
</script>
